import Model from '../Model'
import moment from "moment/moment";
import * as math from "mathjs";

export default class ProgressReport extends Model {
    static updateController = new AbortController();

    static async find(progressReportId) {
        const data = await Http.get(route('api.v2.project-delivery.progress-report', {id: progressReportId}), {})
        return this.make(data)
    }

    static async latest(packageReference) {
        const data = await Http.get(route('api.v2.project-delivery.progress-report.latest', {package_reference: packageReference}), {})
        if (data.id) {
            return this.make(data)
        }
        return null
    }

    static async list(packageReference = null) {
        const data = await Http.get(route('api.v2.project-delivery.progress-report.list', {package_reference: packageReference}))
        return this.make(data)
    }

    async reload() {
        let progress = await ProgressReport.find(this.id)
        Object.assign(this, progress)
    }

    async update() {
        await ProgressReport.updateController.abort()
        ProgressReport.updateController = new AbortController();
        const url = route('api.v2.project-delivery.progress-report.update', {
            package_reference: this.packageReference,
            id: this.id,
        })
        await Http.send('put', url, this, {
            signal: ProgressReport.updateController.signal
        }).catch(err => {
        })
        await this.updateFSPaths()
    }

    async remove() {
        await ProgressReport.updateController.abort()
        ProgressReport.updateController = new AbortController();
        const url = route('api.v2.project-delivery.progress-report.destroy', {
            package_reference: this.packageReference,
            id: this.id,
        })
        await Http.send('delete', url, this, {
            signal: ProgressReport.updateController.signal
        }).catch(err => {
        })
    }
    async complete() {
        await ProgressReport.updateController.abort()
        ProgressReport.updateController = new AbortController();
        const url = route('api.v2.project-delivery.progress-report.complete', {
            package_reference: this.packageReference,
            id: this.id,
        })
        await Http.send('post', url, this, {
            signal: ProgressReport.updateController.signal
        }).catch(err => {
        })
        await this.updateFSPaths()
    }

    async updateFSPaths() {
        let n = await ProgressReport.find(this.id);
        this.filesystemPath = n.filesystemPath
        this.status = n.status
        this.referenceNumber = n.referenceNumber
        n.sections.forEach(section => {
            let oSection = this.sections.find((i) => i.id === section.id)
            oSection.filesystemPath = section.filesystemPath;
            section.tasks.forEach(task => {
                let oTask = oSection.tasks.find((i) => i.id === task.id)
                oTask.filesystemPath = task.filesystemPath;
                task.items.forEach(item => {
                    let oItem = oTask.items.find((i) => i.id === item.id)
                    oItem.filesystemPath = item.filesystemPath;
                    item.components.forEach(component => {
                        let oComponent = oItem.components.find((i) => i.id === component.id)
                        oComponent.filesystemPath = component.filesystemPath;
                    })
                })
            })
        })
    }
    static async create(packageReference, id) {
        ProgressReport.updateController.abort()
        ProgressReport.updateController = new AbortController();
        const url = route('api.v2.project-delivery.progress-report.create', {
            package_reference: packageReference,
            id: id,
        })
        await Http.send('post', url, {
            package_reference: packageReference,
            id: id,
        }, {
            signal: ProgressReport.updateController.signal
        })
    }

    setAttributes(attributes) {
        super.setAttributes(attributes)
        let date = moment(attributes.dateTime)
        this.formatted_date = date.format('DD/MM/YYYY h:mm a')
        this.buildTokens()
    }

    buildTokens() {
        let tokens = []
        this.tokens = tokens.join('|').toLowerCase();
    }
}
